import {Grow, IconButton, useTheme} from "@mui/material";
import React from "react";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';

export default function ScrollTopButton() {
    const theme = useTheme();
    const [visible, setVisible] = React.useState(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        } else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    React.useEffect(() => {
        window.addEventListener('scroll', toggleVisible);
        return () => {
            window.removeEventListener('scroll', toggleVisible);
        };
    }, []);


    return (
        <Grow
            in={visible}
            style={{transformOrigin: '0 0 0'}}
            {...(visible ? {timeout: 1000} : {})}
        >
            <IconButton
                sx={{
                    position: "fixed",
                    bottom: "40px",
                    right: "10%",
                    zIndex: theme.zIndex.drawer,
                }}
                onClick={scrollToTop}
            >
                <ArrowCircleUpIcon sx={{fontSize: 60}}/>
            </IconButton>
        </Grow>
    );
}